// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCommercialAgreementOffers } from '@hooks/queries/commercialAgreements/useCommercialAgreementOffers';
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundCommercialAgreementRequests = () => {
  const { party } = useParties();
  const transform = (data: TemplateContract<CommercialAgreementOffer>[]) => {
    return data.filter((o) => o.payload.user === party).length;
  };
  return useCommercialAgreementOffers(transform);
};
